import { Link } from 'react-router';
import type { MenuItem } from 'types/capi/plp';

type Props = {
  items?: MenuItem[];
  onOptionSelect: (value: string) => void;
};

const SizeFilterGrid = ({ items, onOptionSelect }: Props) => {
  const selectedClassNames = 'bg-forest text-white';
  const unselectedClassNames = 'bg-concrete text-black';

  return (
    <div className="grid w-full grid-cols-4 gap-2 p-4">
      {items?.map((item) => (
        <Link
          onClick={() => onOptionSelect(item.text)}
          data-cy="size-filter-option"
          to={item.path}
          rel="nofollow"
          key={`size-${item.text}`}
          className={`flex h-[38px] w-[52px] items-center justify-center rounded-[4px] text-sm leading-[22px] ${
            item.active ? selectedClassNames : unselectedClassNames
          } rounded`}
        >
          {item.text}
        </Link>
      ))}
    </div>
  );
};

export default SizeFilterGrid;
